import {
  PT_PROMO_PRODUCT_LIST,
  PT_MASTERCATEGORY,
  PT_PRODUCT_LIST,
} from "../../../../routes/stack/paths/pt-home";
import {
  set_dto_selected_merchant_or_product,
  set_dto_MobileAppCategory,
} from "../../../../classes/dto-setters/dto-setter";
import { GET_SELECTED_MERCHANT_OR_PRODCUCT } from "../../../../database/get-stored-data";
import { dto_selected_merchant_or_product } from "../../../../classes/dto-selected-merchant-or-product";
import { ENCRYPT_STORAGE_SESSION, CSP } from "../../../../config/config";
import { Api_DrawAnalyticalPath } from "../../../../connection/api/api-Machine-Learning";
import { F_Fammily, Font } from "../../../../util/config-fonts";
import { KEY_GENERATOR } from "../../../../functions/funtion";
import { dto_common } from "../../../../classes/dto-common";
import { Container } from "react-bootstrap";
import { Colors } from "../../../../util/colors";
import HorizontalCategory from "./horizontol-category";
import React from "react";

export default class ViewCategoryMK extends React.PureComponent {
  render() {
    return (
      <>
        <Container
          style={{ overflowY: "hidden" }}
          className="fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 5,
              marginBottom: 0,
              padding: "0px 10px",
            }}
          >
            <div
              style={{
                fontSize: Font.MainHeading,
                color: Colors.ThemeBGcolor,
                fontFamily: F_Fammily.Medium,
              }}
            >
              CATEGORY
            </div>

            {/* MORE */}
            <div
              style={{
                fontSize: 13,
                fontWeight: "bold",
                display: CSP !== "MK" ? "none" : "block",
              }}
              onClick={() => {
                this.props.navigate(PT_MASTERCATEGORY);
              }}
            >
              More
              <i className="bi bi-chevron-right" style={{ marginLeft: 10 }} />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              overflowY: "auto",
            }}
          >
            {this.props.Data.filter((data) => data.ListType !== 2)
              .slice(0, CSP === "MK" ? 10 : this.props.Data.length)
              .map((data) => {
                if (!data.CategoryImageUrl || data.CategoryImageUrl === "N/A") {
                  data.CategoryImageUrl = dto_common.DefaultImageUrl;
                }

                return (
                  <HorizontalCategory
                    description={data.Category}
                    url={data.CategoryImageUrl}
                    key={KEY_GENERATOR()}
                    callBack={async () => {
                      ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
                      await Api_DrawAnalyticalPath(7, data.CATID);
                      let rs = await GET_SELECTED_MERCHANT_OR_PRODCUCT();
                      rs.CATID = data.CATID;
                      await set_dto_selected_merchant_or_product(rs);
                      dto_selected_merchant_or_product.CATID = data.CATID;
                      set_dto_MobileAppCategory(data);

                      if (
                        data.CATID === 1 &&
                        data.MACID === 1 &&
                        data.Category === "OFFER" &&
                        CSP === "MK"
                      ) {
                        this.props.navigate(
                          PT_PROMO_PRODUCT_LIST.replace(":navPage", "home"),
                        );
                      } else {
                        this.props.navigate(
                          PT_PRODUCT_LIST.replace(":navPage", "home").replace(
                            ":isSec",
                            "false",
                          ),
                        );
                      }
                    }}
                  />
                );
              })}
          </div>
        </Container>
      </>
    );
  }
}
